// Author Liang Gang Qiang
// Date 2021-10-13 17:24:50

import * as model from "@/model/mintalMes/prd/MintalMesPrdFurnaceBatchModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdFurnaceBatch(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
